import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { withStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { useAvailableYears } from "./data";

const styles = theme => ({
  root: {
    marginLeft: 8,
    marginTop: 12,
    width: "100%"
  },
  label: {
    marginBottom: 6
  }
});

const customStyles = {
  option: provided => ({
    ...provided,
    padding: 8
  }),
  control: props => ({
    ...props,
    width: "100%"
  })
};

const animatedComponents = makeAnimated();

//Transformación de valores para la adaptación del Select
const assingItems = (data = []) => {
  const items = [];
  if (data.length > 0) {
    data.forEach(item => {
      const obj = { label: item.representation, value: item.representation };
      items.push(obj);
    });
  }
  return items;
};

/**
 * Componente para la selección de varios items
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0
 */
const SelectSeveral = ({ classes, onChange, typing, indicator, label, placeholder = "Seleccionar", value = [] }) => {
  const { data } = useAvailableYears(indicator, typing);
  return (
    <div className={classes.root}>
      <Typography variant="caption" className={classes.label}>
        {label}
      </Typography>
      <Select
        placeholder={placeholder}
        closeMenuOnSelect={false}
        components={animatedComponents}
        options={assingItems(data)}
        isMulti
        onChange={onChange}
        styles={customStyles}
        theme={theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#0F9C8F"
          }
        })}
        value={value}
      />
    </div>
  );
};

SelectSeveral.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    })
  ),
  selected: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string
};

export default withStyles(styles)(SelectSeveral);



// WEBPACK FOOTER //
// ./src/components/filters/year-selector/multiple.js